export const iconFontAwesomeMathematicsSubscript = (
	<i className="fa-solid fa-subscript"></i>
);
